import React, { useEffect, useMemo } from 'react';
import { useTenantConfig } from 'utils/hooks/useTenantConfig';
import { useAuth } from 'src/utils/hooks/data/useAuth';
import { TimeoutWrapper } from './TimeoutWrapper';

const timeoutKey = 'utmost-timeout-v1';

export const OnIdle: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { signOut } = useAuth();
  const tenantConfig = useTenantConfig();
  const timeoutValueInSeconds = useMemo(
    () => parseInt(tenantConfig?.features?.['inactive-timeout']?.config?.['timeout-seconds'] || '300', 10),
    [tenantConfig?.features]
  );
  const enabled = useMemo(() => tenantConfig?.features?.['inactive-timeout']?.enabled, [tenantConfig?.features]);

  // Bart: Remove it on Jan 2023. This is made to remove an old localStorage entry, not used anymore.
  useEffect(() => {
    localStorage.removeItem(timeoutKey);
  }, []);

  const handleLogout = () => {
    signOut({
      sessionTimeout: true
    });
  };

  return enabled ? <TimeoutWrapper idleTimeout={timeoutValueInSeconds} onLogoutRequest={handleLogout} /> : null;
};
